import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctValue18, FctValue27, FctValue40 } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PROTOCOL_DATA_PROVIDER_ADDRESSES } from '../constants';
export var GetUserReserveData = createPlugin({
    protocol: 'RADIANTV2',
    type: 'GETTER',
    method: 'getUserReserveData',
    supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_protocol_data_provider_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                    user: new FctAddress({}),
                },
            },
            output: {
                currentATokenBalance: new FctValue18({ innerIndex: 0 }),
                currentStableDebt: new FctValue18({ innerIndex: 1 }),
                currentVariableDebt: new FctValue18({ innerIndex: 2 }),
                principalStableDebt: new FctValue18({ innerIndex: 3 }),
                scaledVariableDebt: new FctValue18({ innerIndex: 4 }),
                stableBorrowRate: new FctValue27({ innerIndex: 5 }),
                liquidityRate: new FctValue27({ innerIndex: 6 }),
                stableRateLastUpdated: new FctValue40({ innerIndex: 7 }),
                usageAsCollateralEnabled: new FctBoolean({ innerIndex: 8 }),
            },
        });
    },
    initParams: {
        to: '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d',
    },
});
